export default "__VITE_ASSET__Dh6gaqSD__"